export default __webpack_public_path__ + "static/monitor-illustration-5b27a89d4ff048e3cd1a1c11851ac90c.svg";